'use strict';

var layoutMdl = angular.module('layoutMdl');

layoutMdl.component('layoutFooter', {

    template: require('./layout-footer-template.html')

});

footerCtrl.$inject = ['$scope', '$rootScope'];
function footerCtrl($scope, $rootScope) {



}


// WEBPACK FOOTER //
// ./src/modules/layout/layout-footer-component.js